import styled from 'styled-components';

export const ImageInput = styled.input`
  display: none;
`;
